// Full-document render of the password-reset "done" view: PageSkeleton (the
// React document shell) wrapping the account-page layout -- the brand heading,
// the confirmation copy, the decorative account image, and the customer-service
// info block. The headings / paragraphs / decorative image arrive pre-resolved
// as props (server-side gettext + per-APP_SLUG branding); the customer-service
// block travels as the `cs_info_json` seam.
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { AuthCustomerServiceBlock } from "../components/AuthCustomerServiceBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetDoneDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <div className="account-page-title">
                    <h1>{props.page_copy?.page_heading}</h1>
                </div>

                <section className="account-page-container">
                    <div>
                        <h2>{props.page_copy?.section_heading}</h2>
                        <div>
                            {props.paragraphs.map((paragraph, i) => (
                                <p key={i}>{paragraph}</p>
                            ))}
                        </div>
                    </div>
                    <div>
                        {props.page_copy?.account_image ? (
                            <img
                                src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                                alt={props.page_copy.account_image_alt}
                            />
                        ) : null}
                    </div>
                </section>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </PageSkeleton>
    );
};
